import { useQuery } from '@tanstack/react-query';

import { getVenueAdCampaignConfiguration } from 'apis/ad-bookings/api';

import { CampaignsQueryKeys } from '../campaignsQueryKeys';
import { transformVenueAdCampaignConfigApiToForm } from '../utils/transformApiToForm/transformAdCampaignApiToAdCampaignForm';

export const useAdCampaignVenueConfiguration = ({
  venue,
  country,
  enabled,
  retry = true,
}: {
  venue: string;
  country: Country;
  enabled: boolean;
  retry?: boolean;
}) =>
  useQuery(
    CampaignsQueryKeys.GET_ADS_VENUE_CONFIG(venue, country),
    () => getVenueAdCampaignConfiguration(venue, country),
    {
      refetchOnWindowFocus: false,
      retry,
      enabled,
      select: data => transformVenueAdCampaignConfigApiToForm(data),
    },
  );
